import { useFormContext } from 'react-hook-form';
import {
  GroupType,
  OptionType,
} from '../../../../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { JOINT_ACCOUNTS_LIST, ACCOUNTS_WITHOUT_TRUSTS_LIST } from '../../AccountForm.meta';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const useAccountOwnerSelect = () => {
  const { watch } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const {
    options: { OwnerOptions, JointOwnerOptions, IndividualOwnerOptions },
  } = useAccountFormContext();

  const hasJointOptions = JOINT_ACCOUNTS_LIST.includes(accountType);
  const hasTrustOptions = !ACCOUNTS_WITHOUT_TRUSTS_LIST.includes(accountType);

  const getOptions = () => {
    if (!hasJointOptions && !hasTrustOptions) {
      return IndividualOwnerOptions;
    }

    if (hasJointOptions) {
      return JointOwnerOptions;
    }

    return OwnerOptions;
  };

  const ownerOptions = getOptions();

  return {
    options: Object.keys(ownerOptions).map(key => ({
      label: key,
      options: (ownerOptions[key] || []).map(name => ({ value: name, label: name })),
    })) as GroupType<OptionType<string>>[],
  };
};
